import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../contexts/AuthContext';

const STORAGE_KEY = 'support_last_viewed';

export function useSupportNotifications() {
  const [unreadCount, setUnreadCount] = useState(0);
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      loadCount();

      const interval = setInterval(() => {
        loadCount();
      }, 30000);

      return () => clearInterval(interval);
    }
  }, [user]);

  async function loadCount() {
    if (!user) return;

    try {
      const timeout = setTimeout(() => {
        console.warn('[useSupportNotifications] Query timeout, skipping count');
      }, 3000);

      const { data: tickets } = await supabase
        .from('support_tickets')
        .select('id')
        .eq('user_id', user.id);

      if (!tickets || tickets.length === 0) {
        setUnreadCount(0);
        return;
      }

      const ticketIds = tickets.map(t => t.id);
      const lastViewed = localStorage.getItem(STORAGE_KEY);

      const query = supabase
        .from('ticket_messages')
        .select('*', { count: 'exact', head: true })
        .in('ticket_id', ticketIds)
        .neq('user_id', user.id)
        .eq('is_internal', false);

      if (lastViewed) {
        query.gt('created_at', lastViewed);
      }

      const { count } = await query;
      clearTimeout(timeout);
      setUnreadCount(count || 0);
    } catch (error) {
      console.error('Error loading support notifications:', error);
      setUnreadCount(0);
    }
  }

  function markAsRead() {
    localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    setUnreadCount(0);
  }

  return { unreadCount, markAsRead, refresh: loadCount };
}
